export const secondsToMinutesString = (secs: number) => {
  if (secs <= 60) {
    return `${secs.toFixed(1)}s`;
  }
  const mins = Math.floor(secs / 60);
  const secondsRemaining = secs - mins * 60;
  return `${mins}m ${secondsRemaining < 10 ? '0' : ''}${secondsRemaining.toFixed(0)}s`;
};

export const secondsToColonString = (secs: number) => {
  const hours = Math.floor(secs / 3600);
  const minutes = Math.floor((secs % 3600) / 60);
  const seconds = secs % 60;

  if (hours > 0) {
    return `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds.toFixed(1)}`;
  }
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds.toFixed(1)}`;
};
